import styled from '@emotion/styled';

import { SplashPage } from '../../containers/SplashPage';

export const DataSyncOverlayRoot = styled(SplashPage)`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndices.top};
  background-color: ${({ theme }) => theme.colors.background};
`;
